import { CabinDimensions, LoadingSpaceType } from '../types';
import * as _ from 'lodash';

  export const CabinDimensionsGenerator = (unit: string, loadingSpace: LoadingSpaceType): CabinDimensions  => {
    const dimensions: CabinDimensions = {
      length: 0,
      length1: 0,
      width: 0,
      height: 0,
      height1: 0,
      height2: 0,
      gap: 0,
    };

    if (loadingSpace.type === 1) {
      const scalar = unit === 'cm' || unit === 'mm' ? 1 : 2.54;
      const weightScalar = unit === 'cm' || unit === 'mm' ? 1 : 2.21;
      const isBus = !loadingSpace.limit
        ? loadingSpace.length <= _.round(480 / scalar)
        : loadingSpace.limit <= _.round(1200 * weightScalar);
      const isSolotSet = !loadingSpace.limit
        ? loadingSpace.length >= _.round(481 / scalar) &&
          loadingSpace.length <= _.round(800 / scalar)
        : loadingSpace.limit >= _.round(1201 * weightScalar) &&
          loadingSpace.limit <= _.round(21000 * weightScalar);
      const isStandard = !loadingSpace.limit
        ? loadingSpace.length > _.round(800 / scalar)
        : loadingSpace.limit > _.round(21000 * weightScalar);
      if (isSolotSet) {
        dimensions.length = _.round(150 / scalar);
        dimensions.width = _.round(240 / scalar);
        dimensions.height = _.round(145 / scalar);
        dimensions.height1 = _.round(50 / scalar);
        dimensions.height2 = _.round(15 / scalar);
        dimensions.length1 = _.round(20 / scalar);
      }
      if (isBus) {
        dimensions.length = _.round(170 / scalar);
        dimensions.width = _.round(220 / scalar);
        dimensions.height = _.round(90 / scalar);
        dimensions.height1 = _.round(90 / scalar);
        dimensions.height2 = _.round(20 / scalar);
        dimensions.length1 = _.round(85 / scalar);
      }
      if (isStandard) {
        dimensions.length = _.round(220 / scalar);
        dimensions.width = _.round(270 / scalar);
        dimensions.height = _.round(125 / scalar);
        dimensions.height1 = _.round(100 / scalar);
        dimensions.height2 = _.round(20 / scalar);
        dimensions.length1 = _.round(30 / scalar);
        dimensions.gap = _.round(30 / scalar);
      }
    }
    return dimensions;
  }
